import { BehaviorSubject } from 'rxjs';

const searchInput$ = new BehaviorSubject('');
const searchModal$ = new BehaviorSubject(false);

const setSearchInput = (inputValue: string) => searchInput$.next(inputValue);
const displaySearchModal = (isShow: boolean) => searchModal$.next(isShow);

export const searchService = {
	onSearchModal$: searchModal$.asObservable(),
	displaySearchModal,
	setSearchInput,
	get searchInputValue() {
		return searchInput$.value;
	}
};